import { render } from "./HoldetsRoundCounterOverlay.vue?vue&type=template&id=1cd4bdad"
import script from "./HoldetsRoundCounterOverlay.vue?vue&type=script&lang=js"
export * from "./HoldetsRoundCounterOverlay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__